import { render, staticRenderFns } from "./editDriver.vue?vue&type=template&id=35a00687"
import script from "./editDriver.vue?vue&type=script&lang=js"
export * from "./editDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports